import { render, staticRenderFns } from "./BusinessFeatures.vue?vue&type=template&id=4779e9ab&scoped=true&"
import script from "./BusinessFeatures.vue?vue&type=script&lang=js&"
export * from "./BusinessFeatures.vue?vue&type=script&lang=js&"
import style0 from "./BusinessFeatures.vue?vue&type=style&index=0&id=4779e9ab&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4779e9ab",
  null
  
)

export default component.exports